// @flow
import React from 'react';
import classNames from 'classnames';
import uuid from 'react-uuid';
import { Form, FormikProps, Formik, FormikHelpers, FormikValues } from 'formik';
import * as Yup from 'yup';
import cogoToast from 'cogo-toast';
import api from 'apiClient/api';
import { FormButton } from 'components/molecules/formButton';
import { FormInput } from 'components/molecules/formInput';
import { StringUtil } from 'utils/StringUtil';
import { NumberUtil } from 'utils/NumberUtil';
import { BASE_URL } from 'config/env';
import { CURRENT_SITE_URL } from 'config/env';
import { DateUtil } from 'utils/DateUtil';
import { tables } from './constant.js';
import { RouteNames } from 'router';
import { getGclid } from 'utils/GetGclid.js';

// eslint-disable-next-line
import styles from "./styles.scss";

const API_ENDPOINT = ''; //API For checking whether selected seats are available or not.

type Props = {
  className: string,
  cartValue: number,
  tickets: [],
};

type FormState = {
  name?: string,
  events_gclid_field?: string,
  email_address?: string,
  mobile_number?: string,
};

type State = {
  data: FormState,
};

const initialState: State = {
  data: {
    name: '',
    events_gclid_field: '',
    email_address: '',
    mobile_number: '',
  },
};
export class EventTicketUserForm extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      ...this.getInitialState(),
      isSubmitted: false,
      checked: false,
    };
  }

  getInitialState = () => {
    return {
      data: {
        ...initialState.data,
      },
    };
  };

  handleCheckboxChange = () => this.setState({ checked: !this.state.checked });

  render = () => {
    const { className, cartValue } = this.props;
    const { checked } = this.state;
    const formClass = classNames('form-container', className);
    const buttonMode = 'light';
    const total_amount = cartValue.toFixed(2);
    const formatted_amount = NumberUtil.formatNumber(total_amount);

    return (
      <div className={formClass}>
        <Formik
          initialValues={this.state.data}
          onSubmit={this.onSubmit}
          validationSchema={this.getSchema()}
        >
          {(props: FormikProps<State>) => (
            <Form>
              <FormInput
                id={'event-ticket-user-name'}
                name={'name'}
                label={'Name'}
                placeholder={'Name'}
                type={'text'}
                value={props.values['name']}
              />
               <FormInput
                id={'events_gclid_field'}
                name={'events_gclid_field'}
                type={'hidden'}
                value={props.values['events_gclid_field']}
              />
              <div className={'number-mail-container'}>
                <FormInput
                  id={'event-ticket-email-address'}
                  name={'email_address'}
                  label={'Email Address'}
                  placeholder={'Email Address'}
                  type={'email'}
                  value={props.values['email_address']}
                />
                <FormInput
                  id={'event-ticket-mobile-number'}
                  name={'mobile_number'}
                  label={'Mobile Number'}
                  placeholder={'Mobile Number'}
                  value={props.values['mobile_number']}
                  type={'number'}
                />
              </div>
              <div className={'checkbox-container'}>
                <input type="checkbox" onChange={this.handleCheckboxChange} />
                <p>
                  I understand and agree with the{' '}
                  <a
                    href={RouteNames.conditions}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Terms & Conditions
                  </a>{' '}
                  of Total Environment Music Foundation.
                </p>
              </div>
              <div className={'valuation-summary-container'}>
                <div className={'value-container'}>
                  <h4>Total Order Value(Including GST)</h4>
                  <h3>INR {formatted_amount}</h3>
                </div>
                <FormButton
                  disabled={!checked}
                  mode={buttonMode}
                  text={'Proceed to pay'}
                  className={'pay-button'}
                />
              </div>
            </Form>
          )}
        </Formik>
      </div>
    );
  };

  fetchTablesBooked = (tablesIds) => {
    const activeTableList = tables.filter((item) => {
      return tablesIds.includes(item.id);
    });
    const activeTables = activeTableList.map(function(item) {
      return item['value'];
    });
    return activeTables.toString();
  }

  generateTid() {
    const localTimestamp = Date.now() + (5.5 * 60 * 60 * 1000);
    const randomDigits = Math.floor(Math.random() * 900) + 100; 
    return `${localTimestamp}${randomDigits}`.slice(0, 16);
  }

  // TODO: Common component for toast?
  onSubmit = (values: FormikValues, actions: FormikHelpers<FormikValues>) => {
    getGclid("events");
    const gclidField = document.getElementById('events_gclid_field');
    const trimmedValues = this.trimValues(values);
    const { cartValue, tickets, onError, eventTitle, eventDate } = this.props;
    let { seating_tickets_data, standing_tickets_data } = tickets.ticketData;
    const order_id = uuid();
    const tid = this.generateTid();
    const formatedEventDate = DateUtil.getFullDateString(eventDate);
    const ticket_payload = {
      ...trimmedValues,

      total_amount: cartValue,
      music_event_date_id: tickets.eventTimeID,
      seating_price_per_head: seating_tickets_data.price,
      standing_price_per_head: standing_tickets_data.price,
      total_seating_tickets_booked: seating_tickets_data.selected,
      seating_tickets_data: {
        selectedTableIDs: seating_tickets_data.selectedTableIDs,
      },
      standing_tickets_data: {
        standing_tickets_booked: standing_tickets_data.selected,
      },
      order_id: order_id,
    };
    const tablesBooked = this.fetchTablesBooked(ticket_payload.seating_tickets_data.selectedTableIDs);
    const ticketBooked = (ticket_payload.total_seating_tickets_booked === 0)? `Standing tickets: ${ticket_payload.standing_tickets_data.standing_tickets_booked}`: `Tables: ${tablesBooked}`;  
    const fetchUrl = window.location.href;
    const url = new URL(fetchUrl);
    const utmParameters = {
      UTMSource: url.searchParams.get('utm_source'),
      UTMMedium: url.searchParams.get('utm_medium'),
      UTMCampaign: url.searchParams.get('utm_campaign'),
      UTMDisplay: url.searchParams.get('utm_display'),
      UTMTerm: url.searchParams.get('utm_term'),
      UTMContent: url.searchParams.get('utm_content'),
    };    
    const payload = {
      billing_name:trimmedValues?.name,
      billing_email:trimmedValues?.email_address,
      billing_tel:trimmedValues?.mobile_number,
      merchant_id: '132721',
      order_id: order_id,
      tid: tid,
      currency: 'INR',
      redirect_url: `${BASE_URL}CCAVenueResponseHandler.json`,
      cancel_url: `${BASE_URL}CCAVenueResponseHandler.json`,
      language: 'EN',
      amount: cartValue,
      merchant_param1: `${utmParameters.UTMSource},  ${utmParameters.UTMMedium}`,
      merchant_param2: `${utmParameters.UTMCampaign},  ${utmParameters.UTMDisplay}`,
      merchant_param3: `${utmParameters.UTMTerm},  ${utmParameters.UTMContent}`,
      merchant_param4: `${gclidField.value}`,
      billing_address: `${eventTitle} | ${formatedEventDate} | ${ticketBooked}`
    };    
    api
      .post('bookTicketForEvent.json', ticket_payload)
      .then(res => {
        if (res.data.status === 'success') {
          setTimeout(() => {
            cogoToast.success(
              'Tables selected successfully! waiting for payment confirmation.'
            );
          }, 1000);
          actions.resetForm({ ...this.getInitialState() });
          api.post('CCAVenueRequestHandler.json', payload).then(res => {
            window.open(
              `https://secure.ccavenue.com/transaction/transaction.do?command=initiateTransaction&encRequest=${res.data.encrypted_request}&access_code=${res.data.access_code}`,
              `_self`
              );
            })
        } else {
          setTimeout(() => {
            cogoToast.error(res.data.message);
          }, 1000);
        }
      })
      .catch(error => {
        setTimeout(() => {
          cogoToast.error('Failed to submit your information');
        }, 1000);
        onError();
      })
      .finally(() => {
        this.setState({ isSubmitted: false });
        actions.setSubmitting(false);
      })
  };

  trimValues = (values: FormState): FormState => {
    return Object.keys(values).reduce((trimmed, key) => {
      if (!trimmed[key]) {
        trimmed[key] = values[key].toString().trim();
      }

      return trimmed;
    }, {});
  };

  checkCountrySelected = () => {
    return StringUtil.regexPatterns.phoneINDUS;
  };

  getSchema = () => {
    const schema = {
      name: Yup.string()
        .trim()
        .required('Please enter your First name'),
      email_address: Yup.string()
        .trim()
        .email('Please enter a valid email')
        .required('Please  enter your email'),
      mobile_number: Yup.string()
        .trim()
        .matches(this.checkCountrySelected(), 'enter valid phone number')
        .required('Please enter your phone number'),
    };
    return Yup.object().shape(schema, [['mobile_number', 'email_address']]);
  };
}
